import type { TourKey } from '@osteopro/shared';
import { useSyncExternalStore } from 'react';

/**
 * Demande de visite guidée. Le panneau d'Aide propose « Revoir la visite » sur un écran qui en a
 * une ; la visite elle-même vit avec la mise en route. Ce petit magasin est leur seul point de
 * contact : l'Aide demande, la visite écoute et acquitte.
 */

let requested: TourKey | null = null;
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

/** Demande la visite d'un écran, qu'elle ait déjà été vue ou non. */
export function requestTour(tour: TourKey): void {
  requested = tour;
  emit();
}

/** La visite a démarré : la demande est consommée. */
export function acknowledgeTourRequest(): void {
  if (requested === null) return;
  requested = null;
  emit();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useTourRequest(): TourKey | null {
  return useSyncExternalStore(
    subscribe,
    () => requested,
    () => null,
  );
}

/** Écran → visite. L'Aide s'en sert pour savoir si « Revoir la visite » a un sens ici. */
export function tourForPath(path: string): TourKey | null {
  if (path.startsWith('/agenda')) return 'agenda';
  if (/^\/patients\/(?!import)[^/]+/.test(path)) return 'patient';
  if (path.startsWith('/consultations/')) return 'consultation';
  if (path.startsWith('/invoices')) return 'invoice';
  return null;
}
